import React from "react"
import Modal from "../../shared/Modal";
import CustomButton from "../../shared/CustomButton";
import { CircleWarningFilled, CloseMD, prefix } from "../../normalizer";

const tModal = prefix('gamification2026.sale-trading.accept-modal');

const ConfirmationModal = ({
  selected,
  saleTrade,
  onUnselectObject,
  onAcceptSaleTrade
}) => {

  const handleAcceptAction = e => {
    e.preventDefault()
    onAcceptSaleTrade(saleTrade.id)
  }

  return (
    <Modal show={selected} untoggle={onUnselectObject} extraSmall>
      <div className="gl2026-modal__header">
        <CircleWarningFilled className="gl2026-modal__header-icon" />
        <h4 className="gl2026-modal__title">{tModal('title')}</h4>
        <button
          type="button"
          className="gl2026-modal__close"
          onClick={onUnselectObject}
          aria-label={tModal('close')}
        >
          <CloseMD />
        </button>
      </div>
      <div className="gl2026-modal__body">
        <div className="gl2026-modal__callout gl2026-modal__callout--warning">
          <CircleWarningFilled className="gl2026-modal__callout-icon" />
          <div className="gl2026-modal__callout-content">
            <p className="gl2026-modal__callout-text">{tModal('warning')}</p>
            <p className="gl2026-modal__callout-text">{tModal('confirmation')}</p>
          </div>
        </div>
      </div>
      <div className="gl2026-modal__footer">
        <CustomButton type="button" secondary onClick={onUnselectObject}>
          {tModal('cancel')}
        </CustomButton>
        <CustomButton type="button" onClick={handleAcceptAction}>
          {tModal('accept')}
        </CustomButton>
      </div>
    </Modal>
  )
}

export default ConfirmationModal
